/**
 * Normalize seller ad image URLs for display.
 * - Full URLs (https?://) are returned as-is.
 * - Storage paths (e.g. "seller-ads/uuid/file.jpg") are turned into full
 *   Supabase public object URLs so images load correctly.
 * Use this whenever displaying image_urls from seller_ads (e.g. from API or cache).
 */

const SUPABASE_URL = (typeof process !== 'undefined' && process.env?.REACT_APP_SUPABASE_URL) || '';

/**
 * @param {string|null|undefined} url - Single image URL or storage path
 * @returns {string|null} - Full URL suitable for <img src>, or null
 */
export function getAdImageUrl(url) {
  if (url == null || typeof url !== 'string' || !url.trim()) return null;
  const trimmed = url.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (!SUPABASE_URL) return trimmed; // no base: use as-is (may be relative and fail)
  const path = trimmed.startsWith('/') ? trimmed.slice(1) : trimmed;
  const base = SUPABASE_URL.replace(/\/$/, '');
  return `${base}/storage/v1/object/public/${path}`;
}

/**
 * @param {string[]|null|undefined} urls - Array of image URLs or paths
 * @returns {string[]} - Array of full URLs (skips invalid entries)
 */
export function getAdImageUrls(urls) {
  if (!Array.isArray(urls) || urls.length === 0) return [];
  return urls.map(getAdImageUrl).filter(Boolean);
}
